<template>
  <div class="general-padding" id="order-view">
    <h3>Orders</h3>
    <b-tabs>
      <template slot="tabs">
        <b-nav-item :active="orderStatus == 'RECEIVED'" @click="tabClicked('RECEIVED')">Received</b-nav-item>
        <b-nav-item :active="orderStatus == 'CONFIRMED'" @click="tabClicked('CONFIRMED')">Confirmed</b-nav-item>
        <b-nav-item
          :active="orderStatus == 'ORDER-PREPARING'"
          @click="tabClicked('ORDER-PREPARING')"
        >In Progress</b-nav-item>
        <b-nav-item :active="orderStatus == 'COMPLETED'" @click="tabClicked('COMPLETED')">Completed</b-nav-item>
        <b-nav-item :active="orderStatus == 'CANCELLED'" @click="tabClicked('CANCELLED')">Cancelled</b-nav-item>
      </template>
    </b-tabs>
    <b-row>
      <b-col md="6">Per page &nbsp;&nbsp;&nbsp;
        <b-form-select
          v-model="pagination.limit"
          :options="perPageOptions"
          style="max-width: 100px"
          size="sm"
          @change="pageLimitChanged"
        />
      </b-col>
      <b-col md="6">
        <b-pagination
          :total-rows="pagination.total"
          v-model="pagination.page"
          :per-page="pagination.limit"
          @change="pageChanged"
          aria-controls="content_loop"
          align="right"
        />
      </b-col>
    </b-row>
    <div class="order-list">
      <order-list/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OrderList from '@/components/orders/OrderList.vue';

export default {
  name: 'OrdersMainPage',
  components: {
    OrderList,
  },
  data() {
    return {
      perPageOptions: [10, 20, 30, 50, 100],
    };
  },

  async created() {
    const status = this.orderStatus.trim().length === 0 ? 'RECEIVED' : this.orderStatus;
    this.$store.commit('orderStore/setOrderStatus', status);
    try {
      await this.$store.dispatch(
        'orderStore/getOrdersByStatus',
        status,
      );
    } catch (error) {
      this.$notify({
        group: 'all',
        type: 'error',
        text: `Error occured while getting orders with status: ${status}`,
      });
    }
  },

  methods: {
    async pageChanged(pageNum) {
      const status = this.orderStatus.trim().length === 0 ? 'RECEIVED' : this.orderStatus;
      this.$store.commit('orderStore/setOrderStatus', status);
      this.pagination.page = pageNum;
      this.$store.commit('orderStore/setPagination', this.pagination);
      await this.$store.dispatch('orderStore/getOrdersByStatus', status);
    },

    async pageLimitChanged(limit) {
      this.pagination.limit = limit;
      this.$store.commit('orderStore/setPagination', this.pagination);
      this.pageChanged(1);
    },

    tabClicked(tab) {
      this.$store.dispatch('orderStore/getOrdersByStatus', tab);
    },
  },

  computed: {
    orders() {
      return this.$store.getters['orderStore/getOrdersByStatus'];
    },

    ...mapGetters({
      pagination: 'orderStore/pagination',
      orderStatus: 'orderStore/orderStatus',
    }),
  },
};
</script>

<style lang="scss" scoped>
#order-view {
  .order-list {
    padding: 20px 0px;
  }
}
</style>
